import 'babel-polyfill';
import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { getStatusCode } from '../../selectors/status';
import {
  getUserLegacySettings,
} from '../../selectors/user';
import {
  showPrintVersion,
} from '../../selectors/forecast';
import {
  getCMSMenuLocations,
} from '../../selectors/cms';
import legacyUserSettingsPropType from '../../propTypes/legacyUserSettings';
import { fetchMenuLocations } from '../../actions/cms/menuLocations';
import GlobalHeader from '../../components/GlobalHeader';
import GlobalFooter from '../../components/GlobalFooter';
import PageError from '../../components/Errors/PageError';
import NotFound from '../../components/Errors/NotFound';
import {
  navigatedToPage,
  clickedSubscribeCTA,
} from '../../actions/segmentEvents';

class BuoyweatherPageContainer extends Component {
  static rootContainer = true;
  static fetch = [
    () => fetchMenuLocations(),
  ];

  getClassName = () => classNames({
    'bw-page-container': !this.props.printVersion,
    'bw-page-container--print': this.props.printVersion,
  });

  pageContent = () => {
    const {
      legacyUserSettings,
    } = this.props;
    if (this.props.status === 404) {
      return <NotFound />;
    } else if (this.props.status === 500) {
      return <PageError legacyUserSettings={legacyUserSettings} />;
    }
    return this.props.children;
  }

  render() {
    const {
      locations,
      legacyUserSettings,
      doClickedSubscribeCTA,
      printVersion,
    } = this.props;
    return (
      <div className={this.getClassName()}>
        {!printVersion ?
          <GlobalHeader
            locations={locations}
            user={legacyUserSettings}
            doClickedSubscribeCTA={doClickedSubscribeCTA}
          /> : null}
        <div role="main" id="main">
          {this.pageContent()}
        </div>
        {!printVersion ? <GlobalFooter /> : null}
      </div>
    );
  }
}

BuoyweatherPageContainer.propTypes = {
  printVersion: PropTypes.bool,
  children: PropTypes.node,
  status: PropTypes.number.isRequired,
  legacyUserSettings: legacyUserSettingsPropType.isRequired,
  doClickedSubscribeCTA: PropTypes.func.isRequired,
};

BuoyweatherPageContainer.defaultProps = {
  children: null,
  printVersion: false,
};

export default connect(
  state => ({
    status: getStatusCode(state),
    locations: getCMSMenuLocations(state),
    legacyUserSettings: getUserLegacySettings(state),
    printVersion: showPrintVersion(state),
  }),
  dispatch => ({
    doNavigatedToPage: (name, properties) =>
      dispatch(navigatedToPage(name, properties)),
    doClickedSubscribeCTA: (name, properties) =>
      dispatch(clickedSubscribeCTA(name, properties)),
  }),
)(BuoyweatherPageContainer);



// WEBPACK FOOTER //
// ./src/containers/routes/BuoyweatherPageContainer.js